import EvaluationHome from "../Components/EvaluationPage/Evaluation";

const EvaluationPage = () => {
  return <EvaluationHome />;
};

export default EvaluationPage;
